import { useId } from 'react';
import { useIntl } from 'react-intl';
import { Tag, Tags } from '@/src/listings/types';
import { EventTag } from './components/EventTag/EventTag';
import styles from './EventTags.module.scss';

export interface EventTagsProps {
  tags?: Tags;
  city?: string;
  isOnline?: boolean;
}

export const EventTags = ({ tags, city, isOnline }: EventTagsProps) => {
  const { formatMessage } = useIntl();
  const headingId = useId();

  if (!tags || tags.length === 0) {
    return null;
  }

  const validTags = tags.filter((tag: Tag) => !!tag?.link);

  if (validTags.length === 0) {
    return null;
  }

  const subtitle = isOnline
    ? formatMessage({ id: 'Explore all online events to browse and filter by date, category, and more.' })
    : city
      ? formatMessage(
          { id: 'Explore all events in {city} and filter by date, category, and more to find the perfect fit.' },
          { city },
        )
      : null;

  return (
    <div className={styles.wrapper} data-testid="event-tags" role="region" aria-labelledby={headingId}>
      <h2 id={headingId} className={`${styles.title} ${!subtitle ? styles.titleWithoutSubtitle : ''}`}>
        {formatMessage({ id: 'Still looking for the right event?' })}
      </h2>
      {subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
      <ul className={styles.tagsContainer}>
        {validTags.map((tag: Tag, index) => (
          <EventTag key={index} tag={tag} />
        ))}
      </ul>
    </div>
  );
};
